export enum EBadActions {
  BRIDGE_CURRENCY_TO_ETH = 'bridgeCurrencyToEth',
  TRANSFER_CURRENCY = 'transferCurrency',
}

export enum ERedeemingActions {
  PURCHASE = 'purchase',
}

export enum EGoodActions {
  PLAY_AND_EARN = 'playAndEarn',
  BRIDGE_CURRENCY_TO_GYRI = 'bridgeCurrencyToGyri',
  RUN_NODE = 'runNode',
}

export type EActions = EBadActions | ERedeemingActions | EGoodActions;

export interface IHonorEstimate {
  userId: string;
  action: string;
  actionType: 'good' | 'bad' | 'redeeming';
  game: string;
  honorPoints: number;
}
